import LinkIcon from '@atlaskit/icon/core/link';
import Tooltip from '@atlaskit/tooltip';
import { ExpandIcon } from '@databases/icons';
import React, { Fragment, useState } from 'react';
import { useIntl } from 'react-intl-next';

import { ActionComponent } from '../ActionComponent';
import { type PositionType } from '../actions/entries/select-entries-actions';
import { messages } from '../messages';

import { AddNewEntry } from './AddNewEntry';

type SingleEntryActionsType = {
  handleCopyEntryLink: (setIsCopyLinkCopied: (isCopied: boolean) => void) => void;
  handleExpandEntry: () => void;
  handleInsertEntries: (position: PositionType) => void;
  hasSortedFields: boolean;
  isReadOnly: boolean;
  isEntryPanelActive: boolean;
};

export const SingleEntryActions = ({
  handleCopyEntryLink,
  handleExpandEntry,
  handleInsertEntries,
  hasSortedFields,
  isReadOnly,
  isEntryPanelActive,
}: SingleEntryActionsType) => {
  const { formatMessage } = useIntl();
  const [isEntryLinkCopied, setIsCopyLinkCopied] = useState(false);

  if (isReadOnly) {
    return (
      <Tooltip
        content={
          isEntryLinkCopied &&
          formatMessage(messages['action-bar.single-entry-copied-tooltip'])
        }
        position="top"
      >
        <ActionComponent
          type="copy"
          message={formatMessage(messages['action-bar.single-entry-copy-link'])}
          iconBefore={
            <LinkIcon
              label={formatMessage(messages['action-bar.single-entry-copy-link'])}
            />
          }
          onClick={() => handleCopyEntryLink(setIsCopyLinkCopied)}
        />
      </Tooltip>
    );
  }

  return (
    <Fragment>
      <Tooltip
        content={
          isEntryLinkCopied &&
          formatMessage(messages['action-bar.single-entry-copied-tooltip'])
        }
        position="top"
      >
        <ActionComponent
          type="copy"
          message={formatMessage(messages['action-bar.single-entry-copy-link'])}
          iconBefore={
            <LinkIcon
              label={formatMessage(messages['action-bar.single-entry-copy-link'])}
            />
          }
          onClick={() => handleCopyEntryLink(setIsCopyLinkCopied)}
        />
      </Tooltip>
      {!isEntryPanelActive && (
        <ActionComponent
          type="expand"
          message={formatMessage(messages['action-bar.single-entry-expand-entry'])}
          iconBefore={
            <ExpandIcon
              label={formatMessage(messages['action-bar.single-entry-expand-entry'])}
              spacing="none"
            />
          }
          onClick={handleExpandEntry}
        />
      )}
      {!hasSortedFields && <AddNewEntry handleInsertEntries={handleInsertEntries} />}
    </Fragment>
  );
};
